import * as z from "zod";

export const refreshPrintNodeIntegration = {
  name: "refreshPrintNodeIntegration" as const,
  input: z.object({}),
  output: z.void(),
};
